/**
 * <s-wishlist-count><span data-wishlist-count>0</span></s-wishlist-count>
 *
 * Shows how many products are in the browser wishlist (@theme/wishlist-store); the badge is always
 * visible, including 0. Optional data-label="Wishlist (__count__)" keeps the parent
 * link's aria-label in sync.
 */
import { readWishlist, subscribeWishlist } from "@theme/wishlist-store";

class SWishlistCount extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector("[data-wishlist-count]");
    this.controller = new AbortController();
    subscribeWishlist((list) => this.render(list.length), this.controller.signal);
    this.render(readWishlist().length);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  render(count) {
    if (this.badge) {
      this.badge.textContent = String(count);
    }
    const link = this.closest("a");
    if (link && this.dataset.label) link.setAttribute("aria-label", this.dataset.label.replace("__count__", String(count)));
  }
}

if (!customElements.get("s-wishlist-count")) {
  customElements.define("s-wishlist-count", SWishlistCount);
}
